var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7673 15.7062C19.1037 14.7544 18.7722 13.682 18.7722 12.49C18.7722 11.4035 19.0851 10.4081 19.7096 9.50436C20.0461 9.01399 20.5943 8.44684 21.3539 7.80249C20.854 7.1873 20.3541 6.70653 19.8537 6.36029C18.9499 5.73539 17.9258 5.42294 16.7817 5.42294C16.0992 5.42294 15.2673 5.58631 14.2867 5.91346C13.3444 6.24036 12.6568 6.40398 12.2243 6.40398C11.8972 6.40398 11.2339 6.25986 10.2339 5.97125C9.22432 5.68275 8.37331 5.53863 7.68102 5.53863C6.0272 5.53863 4.66183 6.23101 3.58496 7.61548C2.49844 9.01935 1.95508 10.8173 1.95508 13.0097C1.95508 15.3366 2.66196 17.7546 4.07533 20.2643C5.50788 22.7546 6.95504 23.9999 8.41655 23.9999C8.90692 23.9999 9.54156 23.8364 10.3203 23.5095C11.0993 23.1925 11.7819 23.0336 12.3685 23.0336C12.9933 23.0336 13.7194 23.1874 14.5462 23.495C15.4211 23.8024 16.0944 23.9562 16.5654 23.9562C17.7961 23.9562 19.0319 23.0139 20.2721 21.1294C21.0796 19.9275 21.671 18.7257 22.046 17.5237C21.1902 17.2639 20.4307 16.6581 19.7673 15.7062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8624 4.55759C15.4683 3.95184 15.9154 3.2883 16.2039 2.56727C16.4826 1.84614 16.6217 1.1922 16.6217 0.605597C16.6217 0.567255 16.6197 0.519112 16.6145 0.461371C16.6101 0.403681 16.6075 0.35574 16.6075 0.317246C16.5978 0.288351 16.5859 0.23546 16.5716 0.158623C16.5572 0.081787 16.5452 0.0288957 16.5354 0C14.8431 0.394436 13.6413 1.10592 12.9297 2.1348C12.2088 3.17327 11.8336 4.40872 11.8047 5.84138C12.4489 5.78364 12.9487 5.70205 13.3046 5.59622C13.8243 5.4231 14.3429 5.0768 14.8624 4.55759Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.12802961a9493db60b7cd9dcc6e47572.svg";
export { ForwardRef as ReactComponent };